import { useMemo } from 'react';
import { intersection, isEqual } from 'lodash';
import { UserData } from 'components/UserDataContext/types';
import { getRoles } from '../getRoles';

export const useGetPermission = (roles: string[], userData: UserData | null, anyMatch?: boolean) =>
  useMemo(() => {
    if (!userData) {
      return false;
    }
    const intersectionArray = intersection(roles, getRoles(userData));
    if (anyMatch) {
      return intersectionArray.length > 0;
    }
    return isEqual(intersectionArray, roles);
  }, [userData]);
